import React from "react";
import {
  FaFacebookF,
  FaLinkedin,
  FaPrint,
  FaRegEnvelope,
  FaTwitter,
} from "react-icons/fa";

export interface IListingShareProps {
  className?: string;
  title?: string;
  shareOnFacebook?: boolean;
  shareOnTwitter?: boolean;
  shareOnLinkedIn?: boolean;
  shareOnEmail?: boolean;
  listingPageUrl: string;
  showPrint?: boolean;
  printPageUrl?: string;
}

export const ListingShare: React.FC<IListingShareProps> = ({
  className = "",
  title = "Share Property",
  listingPageUrl,
  shareOnFacebook = true,
  shareOnTwitter = true,
  shareOnLinkedIn = true,
  shareOnEmail = true,
  showPrint = false,
  printPageUrl,
}) => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const fullUrl = `${origin}${listingPageUrl}`;

  return (
    <div className={`listing-share ${className} w-full`}>
      <legend className="w-full uppercase text-accent font-extrabold text-xl leading-6 tracking-wider mb-5">
        {title}
      </legend>
      <div className="w-full listing-share-icons flex flex-row flex-nowrap justify-start gap-x-5 text-3xl">
        {shareOnTwitter && (
          <a
            href={`http://www.twitter.com/share?url=${fullUrl}`}
            target="_blank"
          >
            <FaTwitter />
          </a>
        )}
        {shareOnFacebook && (
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${fullUrl}`}
            target="_blank"
          >
            <FaFacebookF />
          </a>
        )}
        {shareOnLinkedIn && (
          <a
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${fullUrl}`}
            target="_blank"
          >
            <FaLinkedin />
          </a>
        )}
        {shareOnEmail && (
          <a href={`mailto:?body=${fullUrl}`}>
            <FaRegEnvelope />
          </a>
        )}

        {showPrint && printPageUrl && (
          <a href={printPageUrl} target="_blank">
            <FaPrint />
          </a>
        )}
      </div>
    </div>
  );
};

export default ListingShare;
